import { AxiosResponse } from 'axios';

import { ProductCounts } from '../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostProductCounts extends ResponseREST {
	data: [];
}

export const postProductCounts = async (
	body: ProductCounts,
): Promise<ResponseSuccessPostProductCounts> => {
	return axiosInstance
		.post('submit-inv', body)
		.then((res: AxiosResponse<ResponseSuccessPostProductCounts>) => res.data)
		.catch((err) => err);
};
